export default __webpack_public_path__ + "static/media/heart02.b3831a5a.png";